import { Check } from "lucide-react";

import { cn } from "@/shared/lib/utils";

import { TIER_INFO, type IdentityTier } from "../constants/identityTiers.constants";

type HolderAvatarProps = {
  name: string;
  tier: IdentityTier;
  verified?: boolean;
  size?: number;
  className?: string;
};

// Color comes from the tier, not from a name hash — holders in the same tier
// share the look.
export const HolderAvatar = ({ name, tier, verified = false, size = 40, className }: HolderAvatarProps) => {
  const info = TIER_INFO[tier];
  const initials =
    name
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .map((w) => w[0]?.toUpperCase() ?? "")
      .join("") || "?";

  const badgeSize = Math.max(12, Math.round(size * 0.28));

  return (
    <div className={cn("relative shrink-0", className)} style={{ width: size, height: size }}>
      <div
        className="inline-flex items-center justify-center rounded-full font-medium text-white"
        style={{
          width: size,
          height: size,
          background: `linear-gradient(135deg, ${info.color}, ${info.color}cc)`,
          fontSize: Math.round(size * 0.38),
        }}
        aria-hidden="true"
      >
        {initials}
      </div>
      {verified && (
        <span
          className="absolute -bottom-0.5 -right-0.5 inline-flex items-center justify-center rounded-full border-2 border-card bg-success text-success-foreground"
          style={{ width: badgeSize, height: badgeSize }}
          aria-label="KYC verified"
        >
          <Check
            className="text-white"
            strokeWidth={3}
            style={{
              width: Math.max(8, badgeSize - 6),
              height: Math.max(8, badgeSize - 6),
            }}
          />
        </span>
      )}
    </div>
  );
};
